import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'

// COMPONENTS
import AppBar from '../components/app-bar/AppBar'
import RegisterForm from '../components/app-form/RegisterForm'
import { withSnackbar } from 'notistack'

import { translate, Trans } from 'react-i18next'

const styles = theme => ({
  container: {
    height: '100vh',
  },
  content: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: 1,
    flexDirection: 'column ',
  },
})

class Register extends Component {
  state = {
    isFetching: false,
    user: window.state.user,
    initialEmail: window.state.initialEmail,
    errors: '',
  }

  redirect = (url, status) => {
    if (status === 'ok') {
      location.href = url
    }
  }

  handleSubmit = values => {
    this.setState({
      isFetching: true,
    })

    const url = '/register'

    const options = values => ({
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
      body: JSON.stringify(values),
    })

    const handleServerError = message => {
      this.setState({
        isFetching: false,
      })

      if (message.errors && message.status == 422) {
        this.setState({
          errors: message.errors,
        })
      } else {
        const error = `Произошла ошибка на сервере (${message.status}).
        Попробуйте снова или обратитесь в поддержку.`

        this.props.enqueueSnackbar(error, {
          variant: 'error',
          preventDuplicate: true,
          autoHideDuration: 6000,
        })
      }
    }

    function handleResponse(response) {
      return response.json().then(json => {
        if (response.ok) {
          return json
        } else {
          let error = Object.assign({}, json, {
            status: response.status,
            statusText: response.statusText,
          })

          return Promise.reject(error)
        }
      })
    }

    fetch(url, options(values))
      .then(handleResponse)
      .then(({ redirectUrl, status }) => {
        // Отправка события
        window.dataLayer.push({ event: 'Register' })

        this.redirect(redirectUrl, status)
      })
      .catch(message => handleServerError(message))
  }

  render() {
    const { classes } = this.props
    const { user, errors } = this.state

    const islogin = user ? true : false

    return (
      <section className={classes.container}>
        <AppBar islogin={islogin} />
        <main className={classes.content}>
          <div
            style={{
              fontSize: 24,
              maxWidth: 510,
              textAlign: 'center',
              marginBottom: 72,
            }}
          >
            <Trans i18nKey="registration.title">
              Зарегистрируйтесь и получите 14 бесплатных дней на использование
              ROMI center
            </Trans>
          </div>
          <RegisterForm
            onSubmit={this.handleSubmit}
            isFetching={this.state.isFetching}
            errors={errors}
            initialValues={{
              email: this.state.initialEmail,
            }}
          />
          <div style={{ maxWidth: 480, marginTop: 24, textAlign: 'center' }}>
            <Trans i18nKey="[html]registration.terms">
              Нажимая кнопку «Зарегистрироваться», Вы принимаете условия{' '}
              <a href="https://romi.center/docs/ru_terms.pdf">
                Пользовательского соглашения.
              </a>
            </Trans>
          </div>
        </main>
      </section>
    )
  }
}

export default withStyles(styles)(withSnackbar(translate('common')(Register)))
